import script from "./FuelingTransactionDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./FuelingTransactionDetail.vue?vue&type=script&setup=true&lang=ts"

import "./FuelingTransactionDetail.vue?vue&type=style&index=0&id=45635b74&lang=scss&scoped=true"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45635b74"]])

export default __exports__